// extracted by mini-css-extract-plugin
module.exports = {"header-image":"_Layout_header-image_21XVn","terms":"_Layout_terms_2lpdr","logo":"_Layout_logo_3Ae3C"};